<template>
  <svg :viewBox="viewBox" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <polygon class="background" :points="backgroundDimension"></polygon>

    <circle
      v-for="(circle, index) in circles"
      :key="index"
      :r="circleRadius"
      :cx="getCirclePosition(index, 'x')"
      :cy="getCirclePosition(index, 'y')"
      class="lamp"
    ></circle>

    <polygon class="border border--left" fill :points="borderLeft"></polygon>
    <polygon class="border border--top" fill :points="borderTop"></polygon>
    <polygon
      class="border border--bottom"
      fill
      :points="borderBottom"
    ></polygon>
    <polygon class="border border--right" fill :points="borderRight"></polygon>
  </svg>
</template>

<script>
export default {
  props: {
    circleRadius: {
      type: Number,
      required: false,
      default: 5
    },
    dimensions: {
      type: Object,
      required: true
    },
    svgWidth: {
      type: Number,
      default: 1000
    },
    svgHeight: {
      type: Number,
      default: 1000
    },
    svgBorderWidth: {
      type: Number,
      default: 10
    }
  },
  methods: {
    getCirclePosition(index, xOrY) {
      /**
       * Get amount of circles /
       * Get amount of circles per row and per column
       * add two circles to the amount per row (left: 0 and right: maxX) and divide it by width => estimated starting point per circle for cx (circleRadius ignored)
       * get index and check by modulo call the real index
       *
       */
      let circleIndexX = index % this.lampData.rows; //gives you the row index the lamp belongs to
      // let circleIndexY = index % this.lampData.columns; //gives you the column index the lamp belongs to (unused)
      let currentRow = Math.floor(index / this.lampData.rows); //gives you the actual row the current lamp belongs to
      if ("x" === xOrY) {
        let circlePositionX =
          this.normalizedDimensions.width / (Number(this.lampData.rows) + 1); //width between the gaps without substracting circleRadius
        return circlePositionX * (circleIndexX + 1);
      } else {
        let circlePositionY =
          this.normalizedDimensions.roomlength /
          (Number(this.lampData.columns) + 1); //width between the gaps without substracting circleRadius
        return circlePositionY * (currentRow + 1); //use the row to get the y coord
      }
    }
  },
  computed: {
    viewBox() {
      let viewboxString = "0 0 ";
      if (this.dimensions.width > 0 && this.dimensions.roomlength > 0) {
        viewboxString += this.normalizedDimensions.width + " ";
        viewboxString += this.normalizedDimensions.roomlength;
      } else {
        viewboxString += this.svgWidth + " " + this.svgHeight; //attention: svgHeight is the length of a room!
      }
      return viewboxString;
    },
    borderLeft() {
      /**
       * Length: Y-Axis
       * Width: X-Axis
       */
      let borderCoords =
        "0,0 " +
        this.svgBorderWidth +
        ",0  " +
        this.svgBorderWidth +
        "," +
        this.normalizedDimensions.roomlength +
        " 0," +
        this.normalizedDimensions.roomlength +
        "";
      return borderCoords;
    },
    borderTop() {
      let borderCoords =
        "0,0 0," +
        this.svgBorderWidth +
        " " +
        this.normalizedDimensions.width +
        "," +
        this.svgBorderWidth +
        " " +
        this.normalizedDimensions.width +
        ",0";
      return borderCoords;
    },
    borderRight() {
      let borderCoords =
        "" +
        (this.normalizedDimensions.width - this.svgBorderWidth) +
        ",0 " +
        this.normalizedDimensions.width +
        ",0 " +
        this.normalizedDimensions.width +
        "," +
        this.normalizedDimensions.roomlength +
        " " +
        (this.normalizedDimensions.width - this.svgBorderWidth) +
        "," +
        this.normalizedDimensions.roomlength +
        "";
      return borderCoords;
    },
    borderBottom() {
      let borderCoords =
        "0," +
        (this.normalizedDimensions.roomlength - this.svgBorderWidth) +
        " 0," +
        this.normalizedDimensions.roomlength +
        " " +
        this.normalizedDimensions.width +
        "," +
        this.normalizedDimensions.roomlength +
        " " +
        this.normalizedDimensions.width +
        "," +
        (this.normalizedDimensions.roomlength - this.svgBorderWidth) +
        "";
      return borderCoords;
    },
    backgroundDimension() {
      let borderCoords =
        "0,0 0," +
        this.normalizedDimensions.roomlength +
        " " +
        this.normalizedDimensions.width +
        "," +
        this.normalizedDimensions.roomlength +
        " " +
        this.normalizedDimensions.width +
        ",0";
      return borderCoords;
    },
    normalizedDimensions() {
      let normalizedLength = this.svgHeight; //defaults
      let normalizedWidth = this.svgWidth; //defaults
      let aspect =
        this.dimensions.width > 0 && this.dimensions.roomlength > 0
          ? this.dimensions.width / this.dimensions.roomlength || 1
          : 1; //if only one param is already known, use default aspect ratio 1
      if (aspect > 1) {
        //defines querformat
        //width bleibt bei 1000
        normalizedLength = normalizedLength / aspect;
      } else {
        //defines hochkant, height bleibt bei 1000, width wird kleiner
        normalizedWidth = normalizedWidth * aspect;
      }
      // console.log("normalizeDimensions() aspect:", aspect);
      return {
        width: normalizedWidth,
        roomlength: normalizedLength
      };
    },
    lampData() {
      return this.dimensions.lampData;
    },
    circles() {
      //circles are lamps
      let circles = this.lampData.columns * this.lampData.rows;
      return circles;
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
@keyframes pulse_border {
  0% {
    stroke-width: 5px;
    opacity: 1;
  }
  50% {
    stroke-width: 10px;
    opacity: 0.8;
  }
  100% {
    stroke-width: 5px;
    opacity: 1;
  }
}

circle {
  fill: rgb(255, 238, 0);
  stroke: #fbf799;
  stroke-width: 5px;
  transition: all 0.4s;

  animation-name: pulse_border;
  animation-duration: 2000ms;
  transform-origin: center center;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
circle:hover {
  r: 20;
  stroke-width: 10px;
  transition: all 0.4s;
}
.border {
  fill: black;
}
svg {
  max-height: 500px;
}
polygon.background {
  fill: black;
  fill-opacity: 0.3;
}
</style>
